export default __webpack_public_path__ + "static/media/description-date.95ce422d.png";